module.exports = __webpack_public_path__ + "img/img 3@2x.3d6a1f48.png";